import axios from 'axios';

const state = {};
const getters = {};
const mutations = {};

const actions = {
  async getAllEmailLogs(_obj, params) {
    const res = await axios.get('api/campaigns/email-logs/', { params });
    return res.data;
  },
  async getEmailLog(_obj, id) {
    const res = await axios.get(`api/campaigns/email-logs/${id}/`);
    return res.data;
  },
};

export const emailLog = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
